export const SET_GAME = "SET_GAME";
export const SET_TARGET_VALUE = "SET_TARGET_VALUE";
export const SET_TURNS = "SET_TURNS";
export const KICK_PLAYER = "KICK_PLAYER";
export const SET_GAME_STATUS = "SET_GAME_STATUS";
export const SET_GAME_ROLL = "SET_GAME_ROLL";
export const BUY_PROPERTY_ACTION = "BUY_PROPERTY_ACTION";
export const SET_MOVE_TURN = "SET_MOVE_TURN";
export const SET_BALANCE = "SET_BALANCE";
export const GO_TO_JAIL = "GO_TO_JAIL";
export const SET_BUY_BOX = 'SET_BUY_BOX';
export const GAME_ADIOS = 'GAME_ADIOS';
export const SET_OWNER = "SET_OWNER";
